import emailjs from '@emailjs/browser';

// EmailJS configuration
// Get these from https://dashboard.emailjs.com/admin
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || '';
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '';
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '';

// Initialize EmailJS
if (EMAILJS_PUBLIC_KEY) {
  emailjs.init(EMAILJS_PUBLIC_KEY);
}

/**
 * Send email notification for demo request
 * @param {Object} formData - The form data containing name, email, firm, phone
 * @returns {Promise} - Promise that resolves when email is sent
 */
export const sendDemoRequestEmail = async (formData) => {
  // Skip if EmailJS is not configured
  if (!EMAILJS_SERVICE_ID || !EMAILJS_TEMPLATE_ID || !EMAILJS_PUBLIC_KEY) {
    console.warn('EmailJS not configured. Skipping email notification.');
    return Promise.resolve();
  }

  const templateParams = {
    to_email: 'pankaj@levellex.com',
    from_name: formData.name,
    from_email: formData.email,
    firm: formData.firm,
    phone: formData.phone || 'Not provided',
    message: `New demo request from ${formData.name} at ${formData.firm}`,
    subject: `New Demo Request: ${formData.firm}`,
  };

  try {
    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams
    );
    console.log('Email sent successfully:', response);
    return response;
  } catch (error) {
    console.error('Failed to send email:', error);
    // Don't throw error - email failure shouldn't block form submission
    return Promise.resolve();
  }
};

export default sendDemoRequestEmail;

